import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';

export const toggleBoxAnimations = [
  trigger('toggleBox', [
    state(
      'open',
      style({
        height: '*',
        opacity: 1,
      })
    ),
    state(
      'closed',
      style({
        height: '0',
        opacity: 0,
        marginTop: '0',
        overflow: 'hidden',
      })
    ),
    transition('closed => open', [
      animate('280ms cubic-bezier(0.22, 1, 0.36, 1)'),
    ]),
    transition('open => closed', [
      animate('220ms cubic-bezier(0.4, 0, 0.2, 1)'),
    ]),
  ]),
  trigger('chevronRotate', [
    state('open', style({ transform: 'rotate(180deg)' })),
    state('closed', style({ transform: 'rotate(0deg)' })),
    transition('open <=> closed', [
      animate('220ms cubic-bezier(0.4, 0, 0.2, 1)'),
    ]),
  ]),
];
